import React from "react";

import { Button, Col, FormLabel, Row } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { RestReportBean } from "../ds/client_ds.js";
import {
  CommercialInvoiceForMultiplePrintOutRequest,
  CommercialInvoiceSearchCriteria,
  CustomerSearchCriteria,
  InvoiceSearchCriteria,
  PageListBean,
  PurchaseOrderSearchCriteria,
  RestCustomerListRequest,
  RestPageListBean,
  RestPurchaseOrderListRequest,
  RestReadRequest,
  RestSalesOrderRequest,
  SalesOrderSearchCriteria,
} from "../ds/ds.js";
import {
  AlertToolBox,
  ColumnDefinition,
  DataGridColumnDefinition,
  EditableDataGrid,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { PurchaseOrderLookupHandler } from "../lookup/PurchaseOrderLookupHandler.js";
import { SalesOrderLookupHandler } from "../lookup/SalesOrderLookupHandler.js";
import {
  PopupCustomerModule,
  PopupInvoiceModule,
  PopupPickTicketModule,
  PopupSalesModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CustomerService } from "../services/CustomerService.js";
import { InvoiceService } from "../services/InvoiceService.js";
import { PurchaseOrderService } from "../services/PurchaseOrderService.js";
import { ReportService } from "../services/ReportService.js";
import { SalesOrderService } from "../services/SalesOrderService.js";
import { BaseInquiryToolBar } from "./BaseModule.js";
import { ModuleUtils } from "./ModuleUtils.js";
import CustomTable from "../gui_components/CustomTable.js";
class CommercialInvoiceForMultipleInvoice extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: false,
      isShowResetButton: false,
      isShowPDFButton: false,
      pageTitle: "CommercialInvoice For Invoices",
      error_list: [],
      inquiryDataList: [],
      selectedRollSkuList: [],
      criteria: new InvoiceSearchCriteria(),
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMessage: [],
      alertType: "",
      alertMsg: "",
      success_list: [],
      moduleForPopup: [],
      isShowInvoiceModule: false,
      isShowCustomerModule: false,
      isShowExitButton: true,
      isDisabledFields: false,
      isShowLookup: true,
      customerLookupHandler: null,
      salesOrderLookupHandler: null,
      purchaseOrderLookupHandler: null,
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteSalesOrderList: true,
      showAutoCompleteCustomerList: true,
      salesOrderListForAutoCompleteList: new Array(),
      isShowAutoCompletePurchaseOrderList: false,
      purchaseOrderPageListForAutoCompleteList: new Array(),
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isShowSalesModule: false,
      isShowPickTicketModule: false,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.initLookupHandlers();
    ModuleUtils.getPickTicketStatusList();
  }
  initLookupHandlers = () => {
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer"
    );
    this.setState({
      customerLookupHandler: customerLookupHandler,
    });
    let salesOrderLookupHandler = new SalesOrderLookupHandler(
      this.companyCode,
      "SalesOrderNumber"
    );
    this.setState({
      salesOrderLookupHandler: salesOrderLookupHandler,
    });
    let purchaseOrderLookupHandler = new PurchaseOrderLookupHandler(
      this.companyCode,
      "Purchase Order"
    );
    this.setState({
      purchaseOrderLookupHandler: purchaseOrderLookupHandler,
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisabledFields: true,
    });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  customerCodeOnChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let criteria = this.state.criteria;
      criteria.customerCode = "";
      criteria.customerName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCustomerList: showAutoCompleteList,
        criteria: criteria,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList == true &&
      customerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ critera: tempCriteria });
  };
  readandsetCustomterDetail = (customerCode) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Loading ...",
    });
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = customerCode;
    input.isLoadChildren = true;
    CustomerService.readCustomer(
      input,
      this.readandsetCustomterDetailResponse,
      this.errorCallBack
    );
  };
  readandsetCustomterDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;
      if (!isEmpty(customerData)) {
        criteria.customerName = customerData.description;
        criteria.customerCode = customerData.code;
        this.setState({
          criteria: criteria,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
  };
  readCustomerBySearchString = (searchString) => {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let customer_pagelist = new RestPageListBean();
    customer_pagelist.pageSize = 100;
    let customer_requestInput = new RestCustomerListRequest();
    customer_requestInput.pageInput = customer_pagelist;
    customer_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      customer_requestInput,
      this.readByCustomerCodeResponse,
      this.errorCallBack
    );
  };
  readByCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readandsetCustomterDetail(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompleteCustomerList: showAutoCompleteList,
    });
  };
  salesOrderOnChange = (e) => {
    let salesOrderNumber = e.target.value;
    this.state.showAutoCompleteSalesOrderList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteSalesOrderList;
    if (isEmpty(salesOrderNumber)) {
      this.state.showAutoCompleteSalesOrderList = false;
      let showAutoCompleteList = this.state.showAutoCompleteSalesOrderList;
      let criteria = this.state.criteria;
      criteria.salesOrderNumber = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteSalesOrderList: showAutoCompleteList,
        criteria: criteria,
        salesOrderListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "salesOrderNumber" &&
      showAutoCompleteList === true &&
      salesOrderNumber !== ""
    ) {
      this.readSalesOrderBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetSalesOrderDetail = (salesOrderNumber) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Loading ...",
    });
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = salesOrderNumber;
    input.isLoadChildren = true;
    SalesOrderService.readSalesOrder(
      input,
      this.readandsetSalesOrderDetailResponse,
      this.errorCallBack
    );
  };
  readandsetSalesOrderDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.salesOrder != null) {
      let salesOrderData = response.data.salesOrder;
      if (!isEmpty(salesOrderData)) {
        criteria.salesOrderNumber = salesOrderData.code;
        this.setState({
          criteria: criteria,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
  };
  readSalesOrderBySearchString(searchString) {
    let searchCriteria = new SalesOrderSearchCriteria();
    searchCriteria.companycode = this.companyCode;
    searchCriteria.salesOrderNumberStartsWith = searchString;
    searchCriteria.salesOrderNumberContains = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let input = new RestSalesOrderRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    SalesOrderService.getSalesOrderPageList(
      input,
      this.readBySalesOrderCodeResponse,
      this.errorCallBack
    );
  }
  readBySalesOrderCodeResponse = (response) => {
    let salesOrderNumberData = response.data.salesOrderPageList.salesOrders;
    let simpleAutoCompleteList = new Array();
    if (salesOrderNumberData.length > 0 && salesOrderNumberData != null) {
      salesOrderNumberData.map((salesOrderNumber) => {
        let simpleItemBean = {
          code: salesOrderNumber.code,
          description: "",
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      salesOrderListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  salesOrderEnterKeyEventHandler = (e) => {
    let salesOrderNumber = e.target.value;
    this.readandsetSalesOrderDetail(salesOrderNumber);
    this.setState({
      salesOrderListForAutoCompleteList: new Array(),
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  displayAutoCompleteSalesOrderList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompleteSalesOrderList: showAutoCompleteList,
    });
  };
  onPurchaseOrderChange = (e) => {
    let customerPurchaseOrderNumber = e.target.value;
    this.state.isShowAutoCompletePurchaseOrderList = true;
    let criteria = this.state.criteria;
    let showAutoCompleteList = this.state.isShowAutoCompletePurchaseOrderList;
    if (isEmpty(customerPurchaseOrderNumber)) {
      this.state.isShowAutoCompletePurchaseOrderList = false;
      let showAutoCompleteList = this.state.isShowAutoCompletePurchaseOrderList;
      let criteria = this.state.criteria;
      criteria.customerPurchaseOrderNumber = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompletePurchaseOrderList: showAutoCompleteList,
        criteria: criteria,
        purchaseOrderPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerPurchaseOrderNumber" &&
      showAutoCompleteList === true &&
      customerPurchaseOrderNumber !== ""
    ) {
      this.readPurchaseOrderBySearchString(e.target.value);
    }
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  readPurchaseOrderBySearchString(searchString) {
    let searchCriteria = new PurchaseOrderSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.purchaseOrderNumberStartsWith = searchString;
    searchCriteria.purchaseOrderNumberContains = searchString;
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestPurchaseOrderListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    PurchaseOrderService.getPurchaseOrderPageList(
      cust_requestInput,
      this.readPurchaseOrderBySearchStringResponse,
      this.errorCallBack
    );
  }
  readPurchaseOrderBySearchStringResponse = (response) => {
    let purchaseorderData = response.data.purchaseOrderPageList.purchaseOrders;
    let simpleAutoCompleteList = new Array();
    if (response.data.purchaseOrderPageList != null) {
      if (purchaseorderData.length > 0 && purchaseorderData != null) {
        purchaseorderData.map((po) => {
          let simpleItemBean = {
            code: po.code,
            description: "",
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
    }
    this.setState({
      purchaseOrderPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  purchaseOrderEnterKeyEventHandler = (e) => {
    let poCode = e.target.value;
    this.readPurchaseOrder(poCode);
    this.setState({
      purchaseOrderPageListForAutoCompleteList: new Array(),
    });
  };
  readPurchaseOrder = (purchaseOrderCode) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Reading PurchaseOrder ..",
    });
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = purchaseOrderCode;
    PurchaseOrderService.initPurchaseOrderModule(
      readrestInput,
      this.readPurchaseOrderResponse,
      this.errorCallBack
    );
  };
  readPurchaseOrderResponse = (response) => {
    if (
      response.data != null &&
      response.data.purchaseOrderResponse != null &&
      response.data.purchaseOrderResponse.purchaseOrder != null
    ) {
      let poBean = response.data.purchaseOrderResponse.purchaseOrder;
      if (poBean != null) {
        let criteria = this.state.criteria;
        criteria.customerPurchaseOrderNumber = poBean.code;
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
          criteria: criteria,
        });
      }
    }

    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  displayAutoCompletePurchaseOrderList = (showAutoCompleteList) => {
    this.setState({
      isShowAutoCompletePurchaseOrderList: showAutoCompleteList,
    });
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  loadPage = () => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing ...",
    });
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    if (
      !isEmptyString(criteria.customerCode) ||
      !isEmptyString(criteria.salesOrderNumber)
    ) {
      this.loadCommercialInvoiceList(criteria);
    } else {
      let errMsg = "CustomerCode Or SalesOrder# is required!";
      let errList = this.state.error_list;
      errList.push(errMsg);
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  loadCommercialInvoiceList = (criteria) => {
    if (
      SecurityAccessManager.CommercailInvoiceForMultipleInvoiceView_IsAccessible()
    ) {
      InvoiceService.getnvoicesDetailsForCommercialInvoice(
        criteria,
        this.loadCommercialInvoicePageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadCommercialInvoicePageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.result != null) {
      let resultList = new Array();
      if (!isEmptyArray(response.data.result.invoicesDetail)) {
        resultList = response.data.result.invoicesDetail;
        this.setState({
          isShowPDFButton: true,
        });
      }
      this.setState({
        inquiryDataList: resultList,
        isInquiryDatasFound: true,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        isShowLookup: false,
        isShowColorLookup: false,
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  errorCallBack = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error: " + error);
  };

  generateCommInvoicePDF = (e) => {
    if (e.detail == 1) {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Generating ...",
      });
      let selectedRollSkuList = this.state.selectedRollSkuList;
      let rollSkuList = [];
      for (let list of selectedRollSkuList) {
        let invoiceNumbers = list.invoiceNumber;
        rollSkuList.push(invoiceNumbers);
      }
      let roll_criteria = new CommercialInvoiceSearchCriteria();
      roll_criteria.companyCode = this.companyCode;
      roll_criteria.invoiceNumbers = rollSkuList;
      let reportBean = new RestReportBean();
      reportBean.reportType = 1;
      let listRequest = new CommercialInvoiceForMultiplePrintOutRequest();
      listRequest.criteria = roll_criteria;
      listRequest.reportBean = reportBean;
      if (!isEmptyArray(selectedRollSkuList)) {
        this.hideAlertCallBack();
        if (
          SecurityAccessManager.CommercailInvoiceForMultipleInvoice_IsAccessible()
        ) {
          ReportService.getCommercialInvoiceDetailsForMultipleInvoicesReport(
            listRequest,
            this.generatePrintRemainingQtyLabelResponse,
            this.errorCallBack
          );
        } else {
          this.inValidAccess(2);
        }
      } else {
        let errMsg = "Select the Line";
        let error_list = [];
        error_list.push(errMsg);
        this.setState({
          alertMessage: error_list,
          alertType: "danger",
          isShowAlert: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
  };
  generatePrintRemainingQtyLabelResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.loadPage();
    this.setState({
      selectedRollSkuList: [],
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  rollLineCheck = (e, rowData) => {
    let selectedLine = this.state.selectedRollSkuList;
    rowData.isActive = e.target.value;
    if (rowData.isActive == true) {
      selectedLine.push(rowData);
      this.setState({ selectedRollSkuList: selectedLine });
    } else {
      let selectedRollSkuList = this.state.selectedRollSkuList;
      let rollList = [];
      for (let roll of selectedRollSkuList) {
        if (roll.isActive != rowData.isActive) {
          rollList.push(roll);
          this.setState({ selectedRollSkuList: rollList });
        } else if (selectedRollSkuList.length == 1) {
          this.setState({ selectedRollSkuList: [] });
        }
      }
    }
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewCustomerModule = (e,code) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowCustomerModule: true,
        moduleForPopup: (
          <PopupCustomerModule
            customerCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  viewInvoiceModule = (e,code) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowInvoiceModule: true,
        moduleForPopup: (
          <PopupInvoiceModule
            invoiceCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  viewSalesModule = (e,code, rowData) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowSalesModule: true,
        moduleForPopup: (
          <PopupSalesModule code={code} onModuleExit={this.onPopupModalExit} />
        ),
      });
    }
  };
  viewPickTicketModule = (e,code) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowPickTicketModule: true,
        moduleForPopup: (
          <PopupPickTicketModule
            pickTicketCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowInvoiceModule: isOpen,
      isShowCustomerModule: isOpen,
      isShowSalesModule: isOpen,
      isShowPickTicketModule: isOpen,
      moduleForPopup: [],
    });
  };
  getCaption = (status) => {
    return ModuleUtils.getPickTicketStatusCaption(status);
  };
  commercialInvoiceColumns = ()=>{
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("",  "isActive", true)
        .setStyleDetails("left","","","wt-2","wt-2")   
        .setInputDetails(false, false, true, null, this.rollLineCheck,null) 
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Inv#",  "invoiceNumber", true)
        .setStyleDetails("left","","","wt-3","wt-3")   
        .setClickDetails(true, false, this.viewInvoiceModule,null )            
    );
   
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer#",  "customerCode", true)   
        .setStyleDetails("left","","","wt-3","wt-3")   
        .setClickDetails(true, false, this.viewCustomerModule,null )            
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerName",  "customerName", true)  
        .setStyleDetails("left","","","wt-3","wt-3")            
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SalesOrder",  "salesOrderNumber", true)           
        .setStyleDetails("left","","","wt-3","wt-3")   
        .setClickDetails(true, false, this.viewSalesModule,null )     
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PickTicket",  "pickTicketNumber", true)           
        .setStyleDetails("left","","","wt-3","wt-3")   
        .setClickDetails(true, false, this.viewPickTicketModule,null )     
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerP.O#",  "customerPurchaseOrderNumber", true)
        .setStyleDetails("left","","","wt-3","wt-3")   
                
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Status",  "status", true) 
        .setStyleDetails("left","","","wt-3","wt-3")    
        .setStatusDetails(true,this.getCaption)         
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Invoice Date",  "invoiceDate", true)
        .setStyleDetails("left","","","wt-3","wt-3")   
    );
  
   
return columns;
  
  }
  columnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails(
          "",
          "isActive",
          0,
          false, //set hyperlink false
          null, //set hyperLink call back null
          false,
          null
        )
        .setEditableDetails(
          false,
          "",
          null,
          false,
          null,
          true,
          this.rollLineCheck
        )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Inv#",
        "invoiceNumber",
        0,
        true,
        this.viewInvoiceModule
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Customer",
        "customerCode",
        0,
        true,
        this.viewCustomerModule,
        false,
        null
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("CustomerName", "customerName")
    );
    // columnList.push(
    //   new DataGridColumnDefinition().setDetails(
    //     "SalesOrder#",
    //     "salesOrderNumber"
    //   )
    // );
    // columnList.push(
    //   new DataGridColumnDefinition().setDetails(
    //     "PickTicket#",
    //     "pickTicketNumber"
    //   )
    // );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "SalesOrder#",
        "salesOrderNumber",
        0,
        true,
        this.viewSalesModule
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "PickTicket#",
        "pickTicketNumber",
        0,
        true,
        this.viewPickTicketModule
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "CustomerP.O#",
        "customerPurchaseOrderNumber"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Status",
        "status",
        0,
        false,
        null,
        false,
        null,
        "8em", //min-width
        "15%", //max-width
        true,
        ModuleUtils.getPickTicketStatusCaption
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Invoice Date", "invoiceDate")
    );
    return columnList;
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  clearCriteria = () => {
    let tempCriteria = new InvoiceSearchCriteria();
    tempCriteria.companyCode = this.companyCode;
    tempCriteria.customerName = "";
    this.setState({
      criteria: tempCriteria,
    });
    this.hideAlertCallBack();
  };
  resetView = () => {
    let criteria = new InvoiceSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowLookup: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowClearCriteriaButton: true,
      isDisabledFields: false,
    });
    this.hideAlertCallBack();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  moduleExit = () => {
    this.props.onModuleExit();
  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowExitButton={this.state.isShowExitButton}
          extend_toolbar={
            <>
              {this.state.isShowPDFButton && (
                <Button
                  className="header_buttons secondary"
                  size="sm"
                  onClick={(e) => this.generateCommInvoicePDF(e)}
                >
                  {" "}
                  CommInvoice{" "}
                </Button>
              )}
            </>
          }
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          onModuleExit={this.moduleExit}
          reset={this.resetView}
        />
        <CriteriaView
          {...this.state}
          onChange={this.onChange}
          customerCodeOnChange={this.customerCodeOnChange}
          customerCodeEnterKeyEventHandler={
            this.customerCodeEnterKeyEventHandler
          }
          displayAutoCompleteList={this.displayAutoCompleteList}
          salesOrderOnChange={this.salesOrderOnChange}
          salesOrderEnterKeyEventHandler={this.salesOrderEnterKeyEventHandler}
          displayAutoCompleteSalesOrderList={
            this.displayAutoCompleteSalesOrderList
          }
          onPurchaseOrderChange={this.onPurchaseOrderChange}
          purchaseOrderEnterKeyEventHandler={
            this.purchaseOrderEnterKeyEventHandler
          }
          displayAutoCompletePurchaseOrderList={
            this.displayAutoCompletePurchaseOrderList
          }
        />
        {this.state.isInquiryDatasFound && (
          <div className="div_default">
            {/* <EditableDataGrid
              columnsList={this.columnDefinitions()}
              dataList={inquiryDataList}
            /> */}
            <CustomTable
 data={inquiryDataList}
 columns = {this.commercialInvoiceColumns()}
 label={"Commercial Invoice Lines"}
            />
          </div>
        )}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowSalesModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          isShowPopup={this.state.isShowPickTicketModule}
          id="moduleForPopup"
          popupLvlClass={"popupSizeLevel1"}
          module={this.state.moduleForPopup}
          closeModalCallBack={this.closeModalCallBack}
        ></MultiViewPopup>{" "}
      </div>
    );
  }
}
export function CriteriaView(props) {
  const salesOrderOnChange = (e) => {
    props.salesOrderOnChange(e);
  };
  const salesOrderEnterKeyEventHandler = (e) => {
    props.salesOrderEnterKeyEventHandler(e);
  };
  const displayAutoCompleteSalesOrderList = () => {
    props.displayAutoCompleteSalesOrderList();
  };
  const customerCodeOnChange = (e) => props.customerCodeOnChange(e);
  const customerCodeEnterKeyEventHandler = (e) => {
    props.customerCodeEnterKeyEventHandler(e);
  };
  const displayAutoCompleteList = () => {
    props.displayAutoCompleteList();
  };
  const onPurchaseOrderChange = (e) => props.onPurchaseOrderChange(e);
  const purchaseOrderEnterKeyEventHandler = (e) => {
    props.purchaseOrderEnterKeyEventHandler(e);
  };
  const displayAutoCompletePurchaseOrderList = () => {
    props.displayAutoCompletePurchaseOrderList();
  };
  let criteria = props.criteria;
  const customerCodeRef = props.customerCodeRef;
  const purchaseOrderNumberRef = props.purchaseOrderNumberRef;
  let salesOrderRef = React.createRef();
  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          <FormLabel>Customer</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={customerCodeRef}
            name="customerCode"
            onChange={customerCodeOnChange}
            value={criteria.customerCode}
            lookupRequired={props.isShowLookup}
            showCriteriaDialog={true}
            lookupHandler={props.customerLookupHandler}
            enterKeyEventHandler={customerCodeEnterKeyEventHandler}
            autoCompleteListData={props.customerPageListForAutoCompleteList}
            displayAutoCompleteList={displayAutoCompleteList}
            enableAutoCompleteTextBox={true}
            showAutoCompleteList={props.showAutoCompleteCustomerList}
            disabled={props.isDisabledFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="3">
          <InputTextbox
            name="customerName"
            value={criteria.customerName}
            disabled={true}
          />
        </Col>
        <Col sm="1">
          <FormLabel>SalesOrder Number</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={salesOrderRef}
            name="salesOrderNumber"
            value={criteria.salesOrderNumber}
            onChange={salesOrderOnChange}
            lookupRequired={props.isShowLookup}
            showCriteriaDialog={true}
            lookupHandler={props.salesOrderLookupHandler}
            enterKeyEventHandler={salesOrderEnterKeyEventHandler}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteSalesOrderList}
            autoCompleteListData={props.salesOrderListForAutoCompleteList}
            showAutoCompleteList={props.showAutoCompleteSalesOrderList}
            disabled={props.isDisabledFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="1">
          <FormLabel>CustPO#</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={purchaseOrderNumberRef}
            name="customerPurchaseOrderNumber"
            value={criteria.customerPurchaseOrderNumber}
            onChange={onPurchaseOrderChange}
            lookupRequired={props.isShowLookup}
            showCriteriaDialog={true}
            lookupHandler={props.purchaseOrderLookupHandler}
            enterKeyEventHandler={purchaseOrderEnterKeyEventHandler}
            autoCompleteListData={
              props.purchaseOrderPageListForAutoCompleteList
            }
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompletePurchaseOrderList}
            showAutoCompleteList={props.isShowAutoCompletePurchaseOrderList}
            disabled={props.isDisabledFields}
            isMandatory={true}
          />
        </Col>
      </Row>
    </div>
  );
}
function CommercialInvoiceForMultipleInvoiceModule(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div className="App">
        <CommercialInvoiceForMultipleInvoice {...props} name="" /> <br />
      </div>
    </div>
  );
}

export default CommercialInvoiceForMultipleInvoiceModule;
